package com.nonopn.skydome.common.app.pages.main.model

import com.nonopn.skydome.common.app.pages.main.model.api.ThunderDetectionActivity
import com.nonopn.skywatcher.app.utils.Queue
import com.nonopn.skywatcher.maps.LatLng
import kotlinx.coroutines.CoroutineScope

class LightningActivityHolder(scope: CoroutineScope) {
    private val queue = Queue(scope)
    private var left = LatLng(0.0, 0.0)
    private var right = LatLng(0.0, 0.0)
    var state: State = State()
        private set

    suspend fun transaction(block: suspend () -> Unit) {
        queue.enqueue { block() }
    }

    fun setBoundingBox(left: LatLng, right: LatLng): State {
        this.left = left
        this.right = right

        var addedCount = 0
        var removedCount = 0
        var invisibleCount = 0

        state.list.forEach {
            if (it.visible(left, right)) {
                if (null == state.visiblyAdded[it.externalId]) {
                    addedCount++
                    state.visiblyAdded[it.externalId] = it
                }
                state.visible[it.externalId] = it
                state.invisible.remove(it.externalId)
            } else {
                if (null == state.invisible[it.externalId]) {
                    removedCount++
                    state.toRemoveFromVisibleScreen[it.externalId] = it
                }
                invisibleCount++
                state.invisible[it.externalId] = it
                state.visible.remove(it.externalId)
            }
        }

        println("$left / $right  added $addedCount, removed $removedCount, invisible $invisibleCount")

        return state
    }

    fun setLightningActivity(list: List<ThunderDetectionActivity>): State {
        println("setting a new list of activity ${list.size}")

        val removed = state.list.filter { existing ->
            !list.any { it.externalId == existing.externalId }
        }
        state = state.copy(
            list = list,
            removed = removed,
            visible = state.visible.filter { !removed.any { r -> r.externalId == it.value.externalId } }
                .toMutableMap()
        )

        setBoundingBox(left, right)

        return state
    }

    fun commitState() {
        state = state.copy(
            removed = emptyList(),
            visiblyAdded = mutableMapOf(),
            toRemoveFromVisibleScreen = mutableMapOf()
        )
    }

    data class State(
        val list: List<ThunderDetectionActivity> = emptyList(),
        val visible: MutableMap<String, ThunderDetectionActivity> = mutableMapOf(),
        val invisible: MutableMap<String, ThunderDetectionActivity> = mutableMapOf(),
        val removed: List<ThunderDetectionActivity> = emptyList(),
        val visiblyAdded: MutableMap<String, ThunderDetectionActivity> = mutableMapOf(),
        val toRemoveFromVisibleScreen: MutableMap<String, ThunderDetectionActivity> = mutableMapOf(),
    )

    private fun ThunderDetectionActivity.visible(left: LatLng, right: LatLng): Boolean {
        val latInRange = latitude in right.latitude..left.latitude
        val lonInRange = longitude in left.longitude..right.longitude

        return latInRange && lonInRange
    }
}
